import React from "react";
import {
  P,
  SectionHeading,
  SectionSmallHeading,
  SectionWrapper,
} from "../../../styles";
import { Container, Grid } from "@mui/material";
import styled from "@emotion/styled"; 

const Box = styled.div`
  background-color: #fff;
  max-width: 80%;
  padding: 20px;
  @media screen and (max-width: 1250px) {
    max-width: 90%;
  }
  @media screen and (max-width: 599px) {
    max-width: 100%;
  }
`;
const Titles = styled.div`
  display: flex;

  justify-content: space-between;
`;
const TitleOne = styled.div`
  font-family: "two-cent-regular";
  font-size: 14px;
  color: #336799;
`;
const TitleTwo = styled.div`
  color: #336799;
  font-family: "two-cent-regular";
  font-size: 14px;
`;
const Amount = styled.input`
  color: #336799;
  margin-top: 30px;
  background-color: #fff;
  width: 100%;
  height: 50px;
`;
const MaxAmount = styled.div`
  position: relative;
`;
const ButtonRight = styled.div`
  text-align: end;
  margin-top: 20px;
`;
const SendButton = styled.button`
  background-color: #336799;
  border: 0;
  font-family: "twocent-bold-italic";
  width: 120px;
  height: 35px;
`;
const MaxButton = styled.button`
  position: absolute;
  right: 10px;
  bottom: 15px;
  background-color: transparent;
  color: #336799;
  border: none;
  cursor: pointer;
`;
const TBAImage = styled.img`
  width: 100%;
  height: auto;
  max-width: 550px;
`;

const index = () => {
  return (
    <div style={{ backgroundColor: "#36403F" }}>
      <SectionWrapper
        bgColor="#336799"
        id="sacrifice"
        // data-aos="fade-zoom-in"
        // data-aos-easing="ease-in"
        // data-aos-delay="500"
        // data-aos-offset="0"
      >
        <Container maxWidth="xl">
          <SectionHeading fs1250="130px" m="60px" mb="0px" fs="190px">
            Sacrifice
          </SectionHeading>
          <Grid container>
            <Grid xs={12} md={6}>
              <P fs1250="14px" maxWidth="80%">
                For the first 30 days, a ‘Sacrifice Phase’ will be started in
                which the Dollar Inu holders would be able to sacrifice their
                tokens to get eligible for the airdrop of RRT.
                <br />
                <br />
                After the ‘Sacrifice Phase’ has ended, you will not only get an
                equivalent amount of RRT but also your Dollar Inu tokens back.
              </P>
              <Box>
                <Titles>
                  <TitleOne>Dollar Inu you want to sacrifice</TitleOne>
                  <TitleTwo>Balance: 00.00</TitleTwo>
                </Titles>
                <MaxAmount>
                  <Amount type="number" />
                  <MaxButton>Max</MaxButton>
                </MaxAmount>
                <ButtonRight>
                  <SendButton>Send</SendButton>
                </ButtonRight>
                <P fs1250="14px" mb="0px" color="red">
                  Note: Your funds will be locked for 30 days and during this
                  set time period, you will not be able to withdraw your funds.
                  After 30 days, you will get both the Dollar Inu and equiv.
                  amount of RRT in the wallet address you provided.
                </P>
              </Box>
            </Grid>
            <Grid xs={12} md={6}>
              <SectionSmallHeading mt="20px">
                The Sacrifice Phase Has Started
              </SectionSmallHeading>
              <TBAImage
                src="/images/tba.png" 
              />
              <SectionSmallHeading mt="30px" mb="10px">
                Total $DINU Sacrifice
              </SectionSmallHeading>
              <TBAImage
                src="/images/tba.png" 
              />
            </Grid>
          </Grid>
        </Container>
      </SectionWrapper>
    </div>
  );
};

export default index;
